import script from "./ScrollToBottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToBottom.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToBottom.vue?vue&type=style&index=0&id=dfa0ff24&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfa0ff24"]])

export default __exports__